import { Scale, TrendingUp, TrendingDown } from 'lucide-react';
import { MONTHS_RO, fmtRon } from './reportUtils';

const DiffCell = ({ value, testId }) => {
    const positive = value >= 0;
    if (value === 0) {
        return <span data-testid={testId} className="inline-flex px-2.5 py-1 rounded-lg font-medium bg-zinc-100 text-zinc-400">{fmtRon(0)}</span>;
    }
    return (
        <span data-testid={testId} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-lg font-bold ${positive ? 'bg-emerald-50 text-emerald-700' : 'bg-red-50 text-red-700'}`}>
            {positive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            {positive ? '+' : ''}{fmtRon(value)}
        </span>
    );
};

export const MonthlyTable = ({ months, totals, year }) => (
    <div data-testid="monthly-table" className="bg-white border border-zinc-200 rounded-xl p-4 mb-16">
        <h2 className="font-bold text-zinc-800 mb-4 flex items-center gap-2">
            <Scale size={20} className="text-violet-600" />
            Vânzări vs. Cheltuieli — {year}
        </h2>
        <div className="overflow-x-auto">
            <table className="w-full text-sm">
                <thead className="bg-zinc-50 border-b">
                    <tr>
                        <th className="text-left px-4 py-3 font-medium">Luna</th>
                        <th className="text-right px-4 py-3 font-medium">Vânzări (facturi)</th>
                        <th className="text-right px-4 py-3 font-medium">Cheltuieli</th>
                        <th className="text-right px-4 py-3 font-medium">Diferență</th>
                    </tr>
                </thead>
                <tbody>
                    {months.map(m => (
                        <tr key={m.month} data-testid={`month-row-${m.month}`} className="border-b hover:bg-zinc-50">
                            <td className="px-4 py-3 font-medium text-zinc-800">{MONTHS_RO[m.month - 1]}</td>
                            <td className="px-4 py-3 text-right">
                                <span className="font-medium text-zinc-800">{fmtRon(m.sales)}</span>
                                <span className="block text-[11px] text-zinc-400">{m.invoice_count} facturi</span>
                            </td>
                            <td className="px-4 py-3 text-right">
                                <span className="font-medium text-zinc-800">{fmtRon(m.expenses)}</span>
                                <span className="block text-[11px] text-zinc-400">{m.expense_count} cheltuieli</span>
                            </td>
                            <td className="px-4 py-3 text-right"><DiffCell value={m.difference} testId={`month-diff-${m.month}`} /></td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr data-testid="monthly-table-totals" className="bg-zinc-100 font-semibold">
                        <td className="px-4 py-3">Total {year}</td>
                        <td className="px-4 py-3 text-right">{fmtRon(totals.sales)}</td>
                        <td className="px-4 py-3 text-right">{fmtRon(totals.expenses)}</td>
                        <td className="px-4 py-3 text-right"><DiffCell value={totals.profit} testId="month-diff-total" /></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
);
